import { api } from "@/lib/axios";
import { Conversion } from "@/types/dashboard.types";
import { useMutation } from "@tanstack/react-query";

type UpdateConversion = {
  documentId: string;
  conversion: Conversion["conversion"];
  countryId: string;
  batchId: string;
  gradingScaleId: string;
  isFailed?: boolean;
};

export const useUpdateConversion = ({
  documentId,
  conversion,
  countryId,
  gradingScaleId,
  batchId,
  isFailed = false,
}: UpdateConversion) => {
  return useMutation({
    mutationFn: async () => {
      const response = await api.patch(`/api/conversion/update`, {
        id: documentId,
        conversion,
        countryId,
        gradingScaleId,
        isFailed,
        batchId,
      });

      return response.data;
    },
    onSuccess: () => {
      window.location.reload();
    },
  });
};
